<script>
    import { user } from './stores/login_store'
    import CodeDisplay from './sub/CodeDisplay.svelte'
    import HumanTimestamp from './sub/HumanTimestamp.svelte'
    import PasteControls from './sub/PasteControls.svelte'

    import ProgressBar from "./sub/ProgressBar.svelte"

    export let paste_id

    const resolve_paste = async id => {
        const paste = await window.pb.paste_get(`paste_${id}`)
        
        if (!paste.ok) {
            throw new Error(404)
        }

        return paste.paste
    }

    export let render_markdown = false

    const redirect_to_raw = () => {
        location.href = `/view/${paste_id}/raw`
    }
</script>

<style>
    .timestamp {
        margin-top: -1.15em;
    }
</style>


{#await resolve_paste(paste_id)}
<div class="page_container">
    <h1 class="title">Loading...</h1>
    <h2 class="subtitle">Please wait...</h2>
    <ProgressBar/>
</div>
{:then paste}
<div class="page_container" style="padding-bottom: 1em;">
    <h1 class="title">{paste.title}</h1>
    <h2 class="subtitle">
        {#if paste.description}
            <span>{paste.description}</span>
        {:else}
            <i>No description</i>
        {/if}
    </h2>
    <div class="timestamp has-text-dark" on:dblclick={redirect_to_raw}>
        <HumanTimestamp stamp={paste.created}/>
    </div>
</div>

<CodeDisplay
    body={paste.body}
    type={paste.file_type}
    {render_markdown}/>

<div class="page_container">
    <PasteControls paste={paste}/>
    <!--pre>{JSON.stringify(paste, 40, 40)}</pre-->
</div>
{:catch}
<div class="page_container">
    <h1 class="title">File not found!</h1>
    <h2 class="subtitle">
        <a href="/">
            <span class="icon">
                <i class="fas fa-arrow-left"></i>
            </span>
            <span>Back to safety</span>
        </a>
    </h2>
</div>

{/await}

